<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg">
        <img src="assets/svg/contract-icon.svg" alt="icono contrato" />
      </div>
      <div>
        <h4 class="text-semibold">Cambiar propietario del contrato</h4>
        <h6 class="color-gray" style="font-weight: 400;">
          Selecciona el nuevo propietario para la cuenta asociada a este contrato
        </h6>
      </div>
      <div>
        <div class="center-svg">
          <img
            (click)="closeMdl();"
            class="close-button"
            src="assets/svg/close-icon.svg"
            alt="cerrar"
          />
        </div>
      </div>
    </div>

    <div class="mdl-body">
      <div class="mt-3">
        <label class="login-label" for="newOwner">Relacionado con:</label>
        <div style="border: solid 1px #D9D9D9; padding: 4px 10px;">
          <div class="d-grid crm-ng-select">
            <div>
              <img src="assets/svg/user-icon.svg" alt="icono usuario" />
            </div>
            <div>
              <ng-select
                class="crm-ng-select"
                *ngIf="users"
                [items]="users"
                bindLabel="nombreCompleto"
                bindValue="usuario_id"
                placeholder="Buscar usuarios..."
                [(ngModel)]="selectedOwner"
                [searchable]="true"
                [clearable]="true"
              >
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <label class="crm-checkbox-label">
          <input
            type="checkbox"
            class="crm-checkbox"
            [(ngModel)]="sendEmail"
          />
          <span class="crm-checkbox-custom"></span>
          Enviar notificación por correo electrónico al nuevo propietario de la
          cuenta asociada al contrato
        </label>
      </div>

      <div class="mt-3" *ngIf="contrato">
        <b>El nuevo propietario</b> será también el propietario de estos
        registros relacionados con el contrato
        <strong>{{ contrato?.nombre_contrato || contrato?.numero_contrato }}</strong>,
        actualmente asignado a
        <strong>{{ cuentaAsociada?.ejecutivo?.nombre }} {{ cuentaAsociada?.ejecutivo?.apellido }}</strong>:
        <ul>
          <li>Notas y archivos adjuntos.</li>
          <li>Actividades abiertas.</li>
        </ul>
      </div>

      <hr class="mt-4" />

      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button class="btn btn-primary-outline" (click)="closeMdl()">
          Cancelar
        </button>
        <button class="btn btn-primary" (click)="saveChange()">
          Cambiar Propietario
        </button>
      </div>
    </div>
  </div>
</div>
